export default "__VITE_ASSET__C18bup9s__"